export interface LeagueParticipant {
  id: string;
  leagueId: string;
  name: string;
  userId?: string;
  createdAt: Date;
}
